import { Link } from "react-router-dom";

const footerNav = [
  { label: "品牌动态", to: "/news" },
  { label: "生活方式", to: "/lifestyle" },
  { label: "潮流趋势", to: "/trend" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

const friendLinks = [
  { label: "台北设计周", href: "https://dztonaq.cn" },
  { label: "城市生活志", href: "https://dztonaq.cn" },
  { label: "潮流观察", href: "https://dztonaq.cn" },
  { label: "可持续时尚联盟", href: "https://dztonaq.cn" },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信", href: "https://weixin.qq.com" },
  { icon: "ri-weibo-line", label: "微博", href: "https://weibo.com" },
  { icon: "ri-instagram-line", label: "Instagram", href: "https://www.instagram.com" },
  { icon: "ri-youtube-line", label: "YouTube", href: "https://www.youtube.com" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-4 pb-10 pt-14 md:px-8 md:pb-12 md:pt-16 lg:px-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:pr-6">
            <p className="font-heading text-2xl font-extrabold tracking-wide">台北娜娜</p>
            <p className="mt-1 text-[10px] font-medium uppercase tracking-[0.3em] text-background-50/50">
              Taipei Nana
            </p>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-background-50/70">
              聚焦时尚生活与潮流资讯，我们相信品质感藏在日常的细节里，愿与每一位热爱生活的你同行。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  aria-label={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-accent-500"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="font-heading text-sm font-semibold tracking-wide text-background-50">内容导航</p>
            <ul className="mt-5 space-y-3">
              {footerNav.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="cursor-pointer text-sm text-background-50/70 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-heading text-sm font-semibold tracking-wide text-background-50">友情链接</p>
            <ul className="mt-5 space-y-3">
              {friendLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="cursor-pointer text-sm text-background-50/70 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-heading text-sm font-semibold tracking-wide text-background-50">联系我们</p>
            <ul className="mt-5 space-y-3 text-sm text-background-50/70">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line mt-0.5 text-base text-accent-300" />
                <span>台北市信义区松高路 88 号 12 楼</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-phone-line text-base text-accent-300" />
                <a href="tel:+886212345678" className="cursor-pointer transition-colors hover:text-background-50">
                  +886 2 1234 5678
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-base text-accent-300" />
                <a href="mailto:hello@taipeinana.com" className="cursor-pointer transition-colors hover:text-background-50">
                  hello@taipeinana.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-background-50/15 pt-6 text-xs text-background-50/50 sm:flex-row sm:items-center">
          <p>© 2026 台北娜娜 Taipei Nana. 保留所有权利。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>本站内容仅作品牌展示与资讯分享用途</span>
          </p>
        </div>
      </div>
    </footer>
  );
}